import { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Link } from '@backstage/core-components';
import { useNavigate } from 'react-router-dom';
import LinkBreakIcon from './LinkBreakIcon';

interface IErrorPageProps {
  status: string;
  additionalInfo?: ReactNode;
  supportUrl?: string;
}

const useStyles = makeStyles({
  container: {
    textAlign: 'center',
    width: 'inherit',
    height: 'inherit',
    gridArea: 'pageContent',
    paddingTop: '15%',
  },
  errorTitle: {
    textAlign: 'center',
  },
  errorTitleText: {
    fontSize: '20px',
  },
  errorMessageText: {
    fontSize: '36px',
    fontWeight: 'bold',
  },
  infoText: {
    fontSize: '20px',
  },
});

export function AllenErrorPage(props: IErrorPageProps) {
  const { status } = props;
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      <div>
        <LinkBreakIcon />
        <Typography data-testid="error" className={classes.errorTitleText}>
          Error {status}
        </Typography>
        <Typography
          data-testid="error-message"
          className={classes.errorMessageText}
        >
          Oops! Could not find that for you :(
        </Typography>
        <Typography data-testid="error-message" className={classes.infoText}>
          Try{' '}
          <Link to="#" data-testid="go-back-link" onClick={() => navigate(-1)}>
            going back
          </Link>{' '}
          to the previous page or please{' '}
          <Link
            target="_blank"
            data-testid="contact-support"
            to="https://ikea.enterprise.slack.com/archives/C06EYSZJ0H4"
          >
            contact support
          </Link>{' '}
          if you think this is a bug.
        </Typography>
      </div>
    </div>
  );
}
